import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";
import Modal from "@components/ModalTemplate";
import SideBySideLayout from "@components/SideBySideLayout";
import PagesHeader from "@components/PagesHeader";
import Button from "@components/Button";
import BGDesktop from "./img/bg-desktop.jpg";
import BGMobile from "./img/bg-mobile.jpg";
import WarningSrc from "./img/warning.svg";
import "./style.scss";

const ERROR_CONTENT = {
  error_broken_link: {
    title: "Da lief etwas schief...",
    body: "Wir konnten den Code nicht lesen. Bitte scanne den QR‑Code erneut.",
    primaryButton: { label: "Erneut scannen", showScanner: true },
    icon: WarningSrc,
  },
  error_pack_not_found: {
    title: "Da lief etwas schief...",
    body: "Wir konnten den Code nicht lesen. Bitte scanne den QR‑Code erneut.",
    primaryButton: { label: "Erneut scannen", showScanner: true },
    secondaryButton: { label: "Beenden", href: "/qr-scanner-landing" },
    icon: WarningSrc,
  },
  error_activation_not_found: {
    title: "Ups...",
    body: "Diese Aktion ist leider beendet. Weitere Aktivitäten findest du im Inspiration Club.",
    primaryButton: { label: "Zu Inspiration Club", href: "/" },
    secondaryButton: { label: "Beenden", href: "/qr-scanner-landing" },
    icon: WarningSrc,
  },
  error_pack_limit_exceeded: {
    title: "Danke fürs Scannen!",
    body: "Für diesen Monat sind keine weiteren Umfragen verfügbar.",
    primaryButton: { label: "Beenden", closeOnly: true },
  },
  error_pack_already_registered: {
    title: "Code bereits verwendet.",
    primaryButton: { label: "Weiteren Code registrieren", showScanner: true },
    secondaryButton: { label: "Beenden", href: "/qr-scanner-landing" },
    icon: WarningSrc,
  },
  error_generic: {
    title: "Da ist was schief gelaufen",
    body: "Bitte versuch's nochmal oder melde dich nochmal an.",
    primaryButton: { label: "OK", closeOnly: true },
    icon: WarningSrc,
  },
};

const FALLBACK_TYPE = "error_generic";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();
  const type = modal.args?.type ?? FALLBACK_TYPE;
  const { title, body, primaryButton, secondaryButton, icon } =
    ERROR_CONTENT[type] ?? ERROR_CONTENT[FALLBACK_TYPE];

  function handleNav(href) {
    modal.hide();
    navigate(href);
  }

  function handlePrimary() {
    modal.hide();
    switch (true) {
      case primaryButton.closeOnly:
        return;
      case primaryButton.showScanner:
        NiceModal.show("qr-scanner-modal");
        return;
      default:
        navigate(primaryButton.href);
    }
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={handlePrimary}
      onAfterClose={() => modal.remove()}
      innerClass="qr-error-modal"
      disableClose={true}
    >
      <SideBySideLayout position="center" bgImageDesktop={BGDesktop} bgImageMobile={BGMobile}>
        <div className="qr-error-modal__content">
          <PagesHeader back={() => handleNav("/")}>
            <strong>Gehe zu</strong> Inspiration Club
          </PagesHeader>
          <div className="qr-error-modal__inner">
            <div className="qr-error-modal__copy">
              <h1>{title}</h1>
              {body && <p>{body}</p>}
            </div>
            {icon && (
              <img
                className="qr-error-modal__icon"
                src={icon}
                alt=""
                aria-hidden="true"
              />
            )}
          </div>
          <div className="qr-error-modal__footer">
            {secondaryButton && (
              <div className="qr-error-modal__btn-secondary">
                <Button action={() => handleNav(secondaryButton.href)} btnClass="outline">
                  {secondaryButton.label}
                </Button>
              </div>
            )}
            <Button action={handlePrimary} btnClass="ultra-insider">
              {primaryButton.label}
            </Button>
          </div>
        </div>
      </SideBySideLayout>
    </Modal>
  );
});
